import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FriendChatModel from "./FriendChatModel";

function FriendChat(){
    return(
        <Container>
            <center>
                <Row style={{width:"100%"}}>
                    <Col xs="12" lg="3">
                            <></>
                        
                    </Col>
                    <Col xs="12" lg="6" className="p-0">

                        <FriendChatModel/>

                    </Col>
                    <Col xs="12" lg="3">
                        <></>
                    </Col>
                    
                </Row>
            </center>
        </Container>
    )
}

export default FriendChat;